import React, { useEffect, useRef } from 'react'

// Build id du lot de JS effectivement charge par cet onglet. Next l'expose dans
// `__NEXT_DATA__` au rendu de la page, et il ne bouge plus ensuite (les navigations
// client-side reutilisent les memes chunks) : c'est donc bien l'identite des assets
// dont depend l'onglet. Acces par cast, `__NEXT_DATA__` n'etant pas type globalement.
const getLoadedBuildId = (): string | undefined =>
  (window as unknown as { __NEXT_DATA__?: { buildId?: string } }).__NEXT_DATA__?.buildId

function useInterval<P extends Function>(
  callback: P,
  { interval, lead }: { interval: number; lead?: boolean }
): void {
  const savedCallback = useRef<P>(null)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    const tick = (): void => savedCallback.current()

    lead && tick()

    if (interval !== null) {
      const id = setInterval(tick, interval)

      return () => clearInterval(id)
    }
  }, [interval])
}

const DeployRefreshManager: React.FC = () => {
  useInterval(
    async () => {
      const fetchBuildId = async () => {
        const response = await fetch('/api/build-id')

        // During a deploy (the exact situation this poller watches for) the
        // instance behind /api/build-id can be cycling: the proxy answers with
        // an error status or an empty/truncated body, which makes json() throw
        // "Unexpected end of JSON input". There is no build id to read in that
        // case, so we skip this tick and let the next one (30s later) retry.
        if (!response.ok) {
          return null
        }

        const data = await response.json().catch(() => null)

        return data?.buildId
      }
      const servedBuildId = await fetchBuildId()
      const loadedBuildId = getLoadedBuildId()

      if (servedBuildId && loadedBuildId && servedBuildId !== loadedBuildId) {
        // Un nouveau build est en ligne : les chunks dont depend cet onglet ne sont
        // plus servis, il faut recharger avant de tomber sur un "Failed to load chunk".
        window.location.reload()
      }
    },
    { interval: 30000 }
  )

  return null
}

export default DeployRefreshManager
